import { http, param } from '../../utils/http'
import conf from '../../config'

export const API_ROOT = `${conf.API_URL}`
export const API_BASE = `${conf.API_URL}`

const recallsFeedServices = {
    getAllRecallsFeed(payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'search', val: payload.search ? payload.search.trim() : '' },
            { query: 'filterModel', val: payload.filterModel ?  encodeURIComponent(JSON.stringify(payload.filterModel))  : null },
            {query: 'fields', val: payload.fields ? encodeURIComponent(payload.fields) : null},
            { query: 'recallGroup', val: payload.recallGroup || 'Medical Devices' }
        ]
        return http.get(`${API_ROOT}/notisphere/recallfeeds${param(arr)}`).then(resp => {
            return resp
        })
    },
    exportAllRecallsFeed(payload) {
        var query_params = param([
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'search', val: payload.search_query ? payload.search_query.trim() : '' },
            { query: 'filterModel', val: payload.filter_model ? encodeURIComponent(JSON.stringify(payload.filter_model)) : null },
            { query: 'email', val: payload.email ? payload.email : '' },
            { query: 'recallGroup', val: payload.recallGroup || 'Medical Devices' }
        ])
        return http.get(`${API_ROOT}/notisphere/recallfeeds/downloadAgGridRecallFeedxlsx${query_params}`).then(resp => {
            return resp
        })
    },
    getRecallFeed(objectId, recall_type) {
        return http.get(`${API_ROOT}/getrecall?objectId=${objectId}&recall_type=${recall_type}`).then(resp => {
            return resp
        })
    },
    getRecallsFeedMetaData(recall_type) {
        return http.get(`${API_ROOT}/getmeta?recall_type=${recall_type}`).then(resp => {
            return resp
        })
    },
    updateRecallFeed(payload) {
        return http.put(`${API_ROOT}/getrecall`, payload).then(resp => {
            return resp
        })
    },
    getUploadedRecallFilesStatus(sourcePage) {
        const headers = {
            'X-Notisphere-Source': sourcePage || 'recall-feed'
        }
        return http.get(`${API_ROOT}/notisphere/recallfeeds/correction-removal-logs`, { headers }).then(resp => {
            return resp
        })
    },
    updateOpenFDARecallType(payload) {
        const formData = new FormData()
        let sourcePage = payload && payload.sourcePage ? payload.sourcePage : 'recall-feed'
        for (const key in payload) {
            if (key === 'sourcePage') continue
            formData.append(key, payload[key])
        }
        return http.put(`${API_ROOT}/notisphere/recallfeeds/update-recall-type`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-Notisphere-Source': sourcePage
            }
        }).then(resp => {
            return resp
        })
    },
    updateRecallFeedStatus(id, status, isNotApplicable = null) {
        const query_params = param([
            { query: 'status', val: status },
            { query: 'isNotApplicable', val: isNotApplicable }
        ])
        return http.put(`${API_ROOT}/notisphere/recallfeeds/${id}/status${query_params}`, {
            id: id,
            status: status,
            isNotApplicable: isNotApplicable
        }).then(resp => {
            return resp
        })
    },
    getRecallFeedById(id) {
        return http.get(`${API_ROOT}/notisphere/recallfeeds/${id}`).then(resp => {
            return resp
        })
    },
    getRecallPurchaseHistory(id) {
        return http.get(`${API_ROOT}/notisphere/recallfeeds/${id}/purchase-history`).then(resp => {
            return resp
        })
    },
    saveRecallFeedDecision(id, payload) {
        return http.post(`${API_ROOT}/notisphere/recallfeeds/${id}/decision`, payload).then(resp => {
            return resp
        })
    },
    getRecallFeedDecisionHistory(id) {
        return http.get(`${API_ROOT}/notisphere/recallfeeds/${id}/decision-history`).then(resp => {
            return resp
        })
    },
}
export default recallsFeedServices
